<template>
<div>
  <header v-if="item">

<a href="https://mysong.co.il/" target="_blank" class="header-left-logo"></a>

      

<div class="soci">
      <a @click="$emit('open_share')"><i class="fa fa-share-alt"></i><span>שתף</span></a>
      <a :href="item.artist.link" target="_blank" v-if="item.is_more_artist == 1"><i class="fas fa-user"></i><span>עוד מהאמן</span></a>
      
      <a v-if="is_logged && item.is_favorite" @click="remove_fav()"><i class="fas fa-star"></i><span>הסרה</span></a>
      <a v-if="is_logged && !item.is_favorite" @click="add_fav()"><i class="far fa-star"></i><span>למועדפים</span></a>

</div>

  </header>
  <div id="menu_hamburger" v-on:click="$emit('open_side_bar')">
        <div id="nav-icon3"><span></span><span></span><span></span><span></span></div>
      </div>
      <span class="menu_hamburger_title">תפריט</span>
</div>
</template>

<script>
export default {
  props: ["widgets", "item", "user"],
  created(){
    
  },
  computed: {
    is_logged(){
      if (this.user)
      {
      return (this.user.id > 0);
      }
      return false;
    }
  },
  methods: {
    
    add_fav()
    {
      this.item.is_favorite = true; 
      this.$http.post(window.api_url + 'favorites/add', {id:  this.item.id}).then(function(){
      });

    },

    remove_fav()
    {
      this.item.is_favorite = false; 
      this.$http.post(window.api_url + 'favorites/remove', {id:  this.item.id}).then(function(){
        
      });
    }
  }
}
</script>
